import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import HoldingsList from './HoldingsList';
import { icon } from 'leaflet';

//redux

const Holdings = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Holdings' links={breadcrumbLinks} icon={'icon-hotel'} />
					<HoldingsList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Holdings;
